import React from "react";
import { MusicHallTableContainerStyled } from "./styled";
import { connect } from "react-redux";
import { withRouter } from "navigations/withRouter";
import queryString from "query-string";
import { portalService } from "apiServices";
import { ROUTE_PATH } from "utils/constants/routePath";
import moment from "moment";
import { MdAdd } from "react-icons/md";
import { toast } from "react-toastify";
import { Buttons, Displays, Tables } from "components";

class MusicHallTableContainer extends React.Component {
  state = {
    filterValue: "day",
    isLoading: true,
    isFullscreen: false,
  };

  componentDidMount() {
    const query = this.buildQueryString();
    this.fetchData(query);
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
    document.addEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    );
    document.addEventListener("keydown", this.handleFullscreenKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener("keydown", this.handleFullscreenKeyDown);
    // กดการ์ดตอนเต็มจอ → ไปหน้า detail ให้ออกจากเต็มจอด้วย ไม่งั้นหน้า detail ค้างโหมดเต็มจอ
    this.exitBrowserFullscreen();
  }

  // FULLSCREEN
  // =========================================
  // =========================================
  // สั่ง requestFullscreen ที่ <html> ทั้งหน้า แล้วใช้ CSS (position: fixed) ขยายกล่องตารางให้เต็มจอเอง
  // ไม่สั่งที่กล่องตารางตรง ๆ เพราะโหมดเต็มจอของเบราว์เซอร์แสดงเฉพาะลูกหลานของ element นั้น
  // ป๊อปอัพยืนยันปิดช่วงเวลา (Modals.Alert) กับ toast อยู่ที่ App.js นอกกล่อง → จะไม่โผล่ตอนเต็มจอ
  // กล่องตารางอยู่นอก Loading เพื่อให้เปลี่ยนวัน/สัปดาห์แล้วยังเต็มจออยู่
  isBrowserFullscreen = () =>
    !!(document.fullscreenElement || document.webkitFullscreenElement);

  exitBrowserFullscreen = () => {
    if (!this.isBrowserFullscreen()) return;
    const exit = document.exitFullscreen || document.webkitExitFullscreen;
    if (!exit) return;
    try {
      const p = exit.call(document);
      if (p && p.catch) p.catch(() => {});
    } catch (e) {}
  };

  handleToggleFullscreen = () => {
    if (this.state.isFullscreen) {
      this.setState({ isFullscreen: false });
      this.exitBrowserFullscreen();
      return;
    }
    this.setState({ isFullscreen: true });
    const el = document.documentElement;
    const request = el.requestFullscreen || el.webkitRequestFullscreen;
    if (!request) return; // เบราว์เซอร์ไม่รองรับ → ใช้แค่กล่องเต็มหน้าต่าง
    try {
      const p = request.call(el);
      if (p && p.catch) p.catch(() => {});
    } catch (e) {}
  };

  // กด Esc ในโหมดเต็มจอของเบราว์เซอร์ → เบราว์เซอร์ออกเอง ต้องปิดกล่องตามด้วย
  handleFullscreenChange = () => {
    if (!this.isBrowserFullscreen() && this.state.isFullscreen) {
      this.setState({ isFullscreen: false });
    }
  };

  // กรณีเบราว์เซอร์ไม่ยอมเข้าเต็มจอ (เหลือแค่กล่องเต็มหน้าต่าง) ให้ Esc ปิดได้เหมือนกัน
  handleFullscreenKeyDown = (e) => {
    if (
      e.key === "Escape" &&
      this.state.isFullscreen &&
      !this.isBrowserFullscreen()
    ) {
      this.setState({ isFullscreen: false });
    }
  };

  fetchData = async (query) => {
    let resArr = await Promise.all([
      portalService.GET_ROOM_AVAILABILITY_LIST(query),
      portalService.GET_ROOM_BOOKING_LIST(query),
      portalService.GET_ROOM_LIST(`?pagination=false&is_active=true`),
    ]);
    if (resArr) {
      this.setState({
        dataAvailability: resArr[0].data,
        data: resArr[1].data,
        dataRoom: resArr[2].data.docs.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        ),
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  // QUERY FLOW
  // =========================================
  // =========================================
  buildQueryString = (additionalParams = {}) => {
    const { router } = this.props;
    const urlParams = queryString.parse(router.location.search);
    const defaultQuery = {
      pagination: false,
      start_date: moment().format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
    };
    const finalParams = {
      ...defaultQuery,
      ...urlParams,
      ...additionalParams,
    };
    const cleanParams = Object.entries(finalParams)
      .filter(
        ([key, value]) => value !== null && value !== undefined && value !== ""
      )
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
    const query = `?${Object.entries(cleanParams)
      .map(([key, value]) => `${key}=${value}`)
      .join("&")}`;
    router.navigate(`${ROUTE_PATH.MUSIC_HALL_BOOKING_TABLE}${query}`);
    return query;
  };
  handleFilterKeyword = (e) => {
    const queryParams =
      typeof e === "string" ? queryString.parse(e.replace("?", "")) : e;
    this.handleJoinQuery(queryParams);
  };
  handleChangeFilter = (e) => {
    const { dataRoom } = this.state;
    const startDate =
      e === "day"
        ? moment().format("YYYY-MM-DD")
        : moment().startOf("week").format("YYYY-MM-DD");
    const endDate =
      e === "day"
        ? moment().format("YYYY-MM-DD")
        : moment().endOf("week").format("YYYY-MM-DD");
    this.setState({
      filterValue: e,
    });
    let additionalQuery = {
      start_date: startDate,
      end_date: endDate,
    };
    if (e === "week") {
      let findFirstRoomId = dataRoom.find((e) => e.type === "1");
      additionalQuery.room_id = findFirstRoomId
        ? findFirstRoomId._id
        : dataRoom[0]._id;
      this.setState({
        selectedRoomId: additionalQuery.room_id,
      });
    } else {
      additionalQuery.room_id = "";
      this.setState({
        selectedRoomId: "",
      });
    }
    this.handleJoinQuery(additionalQuery);
  };
  handleChangeRoom = (e) => {
    this.setState({
      selectedRoomId: e,
    });
    this.handleJoinQuery({ room_id: e });
  };
  handleDateFilter = (key, e) => {
    const { router } = this.props;
    const { filterValue } = this.state;
    const startDate =
      queryString.parse(router.location.search)?.start_date ||
      moment().format("YYYY-MM-DD");
    switch (key) {
      case "next":
        const tempNextStartDate =
          filterValue === "day"
            ? moment(startDate, "YYYY-MM-DD").add(1, "day").format("YYYY-MM-DD")
            : moment(startDate, "YYYY-MM-DD")
                .add(7, "day")
                .format("YYYY-MM-DD");
        const tempNextendDate =
          filterValue === "day"
            ? moment(startDate, "YYYY-MM-DD").add(1, "day").format("YYYY-MM-DD")
            : moment(startDate, "YYYY-MM-DD")
                .add(13, "day")
                .format("YYYY-MM-DD");
        this.handleJoinQuery({
          start_date: tempNextStartDate,
          end_date: tempNextendDate,
        });
        break;
      case "prev":
        const tempPrevStartDate =
          filterValue === "day"
            ? moment(startDate, "YYYY-MM-DD")
                .subtract(1, "day")
                .format("YYYY-MM-DD")
            : moment(startDate, "YYYY-MM-DD")
                .subtract(7, "day")
                .format("YYYY-MM-DD");
        const tempPrevEndDate =
          filterValue === "day"
            ? moment(startDate, "YYYY-MM-DD")
                .subtract(1, "day")
                .format("YYYY-MM-DD")
            : moment(startDate, "YYYY-MM-DD")
                .subtract(1, "day")
                .format("YYYY-MM-DD");
        this.handleJoinQuery({
          start_date: tempPrevStartDate,
          end_date: tempPrevEndDate,
        });
        break;
      case "select":
        const tempSelectStartDate =
          filterValue === "day"
            ? moment(e, "YYYY-MM-DD").format("YYYY-MM-DD")
            : moment(e, "YYYY-MM-DD").startOf("week").format("YYYY-MM-DD");
        const tempSelectEndDate =
          filterValue === "day"
            ? moment(e, "YYYY-MM-DD").format("YYYY-MM-DD")
            : moment(e, "YYYY-MM-DD").endOf("week").format("YYYY-MM-DD");
        this.setState({
          startDate: tempSelectStartDate,
          endDate: tempSelectEndDate,
        });
        this.handleJoinQuery({
          start_date: tempSelectStartDate,
          end_date: tempSelectEndDate,
        });
        break;
      default:
        break;
    }
  };
  handlePageClick = (e) => {
    this.handleJoinQuery({ page: e.selected + 1 });
  };
  handleJoinQuery = (additionalQuery) => {
    const query = this.buildQueryString(additionalQuery);
    this.setState({
      isLoading: true,
    });
    this.fetchData(query);
  };

  handleClickCreate = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.MUSIC_HALL_BOOKING}/${e}`);
  };

  handleSubmit = async (values) => {
    const { router } = this.props;
    const { dataRoom } = this.state;
    let dataCheck = Object.keys(values).reduce((result, data) => {
      let split = data.replaceAll("_", ".").split("-");
      if (values[data] === true) {
        result.push({ startTime: split[0], endTime: split[1], isClose: true });
      }
      if (values[data] === false) {
        result.push({ startTime: split[0], endTime: split[1], isClose: false });
      }
      return result;
    }, []);
    if (dataCheck && dataCheck.length > 0) {
      this.setState({
        isLoading: true,
      });
      let res = await Promise.all(
        dataCheck.map((e) => {
          return new Promise(async (resolve) => {
            let params = {
              room_ref_id: dataRoom.map((e) => e._id).join(","),
              date: queryString.parse(router.location.search)?.start_date,
              start_time: e.startTime,
              end_time: e.endTime,
              reason_closed: "2",
              isClose: e.isClose,
            };
            let resUpdate = await portalService.POST_ROOM_AVAILABILITY_DETAIL(
              params
            );
            if (resUpdate && resUpdate.status === 200) {
              resolve({
                status: 200,
              });
            } else {
              resolve({
                status: 400,
              });
            }
          });
        })
      );
      if (res) {
        toast.success("อัพเดตสำเร็จ");
        this.fetchData(
          `?pagination=false&start_date=${
            queryString.parse(router.location.search)?.start_date
          }&end_date=${
            queryString.parse(router.location.search)?.end_date
          }&date_type=booking_date`
        );
      }
    }
  };

  handleClickClosedDay = async (room, timeSlot, isClosed) => {
    const { router } = this.props;
    this.setState({
      isBgLoading: true,
    });
    let params = {
      room_ref_id: room._id,
      date:
        queryString.parse(router.location.search)?.start_date ||
        moment().format("YYYY-MM-DD"),
      start_time: timeSlot.startTime,
      end_time: timeSlot.endTime,
      reason_closed: "2",
      isClose: isClosed,
    };
    let resUpdate = await portalService.POST_ROOM_AVAILABILITY_DETAIL(params);
    if (resUpdate && resUpdate.status === 200) {
      this.setState({
        isBgLoading: false,
      });
      toast.success("อัพเดตสำเร็จ");
      const query = this.buildQueryString();
      this.fetchData(query);
    } else {
      this.setState({
        isBgLoading: false,
      });
      toast.error("อัพเดตไม่สำเร็จ");
    }
  };

  render() {
    const { router, authenRedux } = this.props;
    const {
      isBgLoading,
      isLoading,
      data,
      dataAvailability,
      dataRoom,
      filterValue,
      isFullscreen,
      selectedRoomId,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find(
          (e) => e.menu_key === "music-hall-booking"
        );
    const startDate = queryString.parse(router.location.search)?.start_date;
    return (
      <MusicHallTableContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {permission && permission.is_create && (
          <div className="btn_create">
            <Buttons.BgIconPrefix
              label="New Booking"
              icon={<MdAdd size={18} />}
              onClick={() => this.handleClickCreate("create")}
            />
          </div>
        )}
        <div className="filter_layout"></div>
        <div className={`table_wrap${isFullscreen ? " is_fullscreen" : ""}`}>
          {isLoading ? (
            <Displays.Loading theme_standard_loading />
          ) : (
            <Tables.SchedulerMusicHall
              columns={dataRoom}
              selectedRoomId={selectedRoomId}
              customerData={data.docs}
              dateFilterValue={startDate || moment().format("YYYY-MM-DD")}
              filterValue={filterValue}
              holidayData={dataAvailability.docs
                .filter((e) => e.reason_closed === "1")
                .map((f) => moment(f.date).format("YYYY-MM-DD"))}
              permission={permission}
              timeSlotData={dataAvailability.docs.filter(
                (e) => e.reason_closed !== "1"
              )}
              onClickClosed={this.handleClickClosedDay}
              onChangeFilter={this.handleChangeFilter}
              onChangeRoom={this.handleChangeRoom}
              onDateFilter={this.handleDateFilter}
              onSubmit={this.handleSubmit}
              isFullscreen={isFullscreen}
              onToggleFullscreen={this.handleToggleFullscreen}
            />
          )}
        </div>
      </MusicHallTableContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MusicHallTableContainer));
